import firstImg from './team/1.png';
import secondImg from './team/2.png';
import thirdImg from './team/3.png';
import fourthImg from './team/4.png';
import fifthImg from './team/5.png';
import sixthImg from './team/6.png';
import seventhImg from './team/7.png';
import eighthImg from './team/8.png';
import ninethImg from './team/9.png';
import tenthImg from './team/10.png';
import eleventhImg from './team/11.png';
import twelfthImg from './team/12.png';

export const firstRow = [
  {
    name: 'Nikita Olekhno',
    // position: 'Team Leader',
    position_academ: 'Assistant Professor',
    personImg: firstImg,
    description:
      'Group leader, PhD in Physics. Scientific interests are focused on studies of robotic active matter to bridge the gap between novel phenomena and applications by conducting projects at the interface of academia and industry.',
    email: 'nikita.olekhno@itmo.ru',
    LinkedIn: 'https://www.linkedin.com/in/olekhnon/',
    GoogleSC: 'https://scholar.google.com/citations?user=CaRkJykAAAAJ&hl=en',
    ResearchGate: 'https://www.researchgate.net/profile/Nikita-Olekhno',
  },
  {
    name: 'Alexey Dmitriev',
    // position: 'Lead Circuit Development',
    position_academ: 'Postdoc',
    personImg: secondImg,
    description: 'PhD graduated student at the Faculty of Physics. Develops the circuitry and firmware.',
    email: 'alexey.dmitriev@itmo.ru',
    LinkedIn: null,
    GoogleSC: 'https://scholar.google.com/citations?user=gSTJ8qQAAAAJ&hl=en',
    ResearchGate: 'https://www.researchgate.net/profile/Alexey-Dmitriev-5',
  },
  {
    name: 'Vadim Porvatov',
    // position: 'Lead Software Development, ML',
    position_academ: 'Research Engineer',
    personImg: thirdImg,
    description:
      'Has research experience in statistical processing of physical experiments, computer vision, and graph machine learning.',
    email: 'eighonet@gmail.com',
    LinkedIn: 'https://www.linkedin.com/in/eighonet/',
    GoogleSC: 'https://scholar.google.com/citations?hl=en&user=PaH-exwAAAAJ',
    ResearchGate: 'https://www.researchgate.net/profile/Vadim-Porvatov',
  },
];

export const secondRow = [
  {
    name: 'Alina Rozenblit',
    // position: 'Lead Design Development, Physics',
    position_academ: '4th year Phd student',
    personImg: fourthImg,
    description: null,
    email: 'alina.rozenblit@metalab.ifmo.ru',
    LinkedIn: 'https://www.linkedin.com/in/alina-rozenblit-8b9a1a20b/',
    GoogleSC: 'https://scholar.google.com/citations?user=MWWrTuAAAAAJ&hl=en',
    ResearchGate: 'https://www.researchgate.net/profile/Alina-Rozenblit-2',
  },
  {
    name: 'Anastasia Molodtsova',
    // position: 'Physics',
    position_academ: '1st year Phd student',
    personImg: fifthImg,
    description:
      'PhD student of the Faculty of Physics who conducts experiments with swarms of robots and models systems of active matter',
    email: 'a.molodtsova@metalab.ifmo.ru',
    LinkedIn: null,
    GoogleSC: 'https://scholar.google.ru/citations?user=rFr40toAAAAJ&hl=ru&oi=ao',
    ResearchGate: 'https://www.researchgate.net/profile/Anastasia-Molodtsova',
  },
  {
    name: 'Oleg Burmistrov',
    // position: 'Circuit Development',
    position_academ: 'Phd Graduate',
    personImg: sixthImg,
    description:
      'PhD student with a great passion to kilovolts, kilowatts, and kiloamperes. The main qualifications are in the areas of developing and soldering electronic circuits, incuding wireless power transfer applications.',
    email: 'oleg.burmistrov@metalab.ifmo.ru',
    LinkedIn: null,
    GoogleSC: 'https://scholar.google.com/citations?user=3X5z57kAAAAJ&hl=en',
    ResearchGate: 'https://www.researchgate.net/profile/Oleg-Burmistrov',
  },
];

export const thirdRow = [
  {
    name: 'Mikhail Buzakov',
    position_academ: 'Student',
    // position: 'Physics',
    personImg: eighthImg,
    description:
      'A student of the Faculty of Physics, who is engaged in the processing of experimental data and the automation of this process. Loves programming and iced coffee',
    email: 'mikhail.buzakov@metalab.ifmo.ru',
    LinkedIn: null,
    GoogleSC: null,
    ResearchGate: null,
  },
  {
    name: 'Vyacheslav Timofeev',
    // position: 'Physics',
    position_academ: 'Student',
    personImg: twelfthImg,
    description:
      null,
    email: 'v.timofeev@metalab.ifmo.ru',
    LinkedIn: null,
    GoogleSC: null,
    ResearchGate: null,
  },
  {
    name: 'Timofey Vechkanov',
    // position: 'Physics',
    position_academ: 'Student',
    personImg: ninethImg,
    description: null,
    email: 'timofei.vechkanov@metalab.ifmo.ru',
    LinkedIn: null,
    GoogleSC: null,
    ResearchGate: null,
  },
];

export const fourthRow = [
  {
    name: 'Vyacheslav Smirnov',
    // position: 'Physics',
    position_academ: null,
    personImg: tenthImg,
    description:
      'Student of the Department of Nanoelectronics and laboratory assistant of the Faculty of Physics, who is engaged in the processing of experimental data and automation of this process, as well as the collection of experimental data and automation of experiments. Likes to travel and do robotics.',
    email: 'v.smirnov@metalab.ifmo.ru',
    LinkedIn: 'https://www.linkedin.com/in/obieshka/',
    GoogleSC: null,
    ResearchGate: null,
  },
  {
    name: 'Daria Sennikova',
    // position: 'Modeling',
    position_academ: null,
    personImg: eleventhImg,
    description:
      'Student of the Faculty of Nanoelectronics who does some of the experiments with Swarmodroids, plot graphs based on experimental data, models in COMSOL and actively studies the physics of nanoparticles',
    email: 'daria.sennikova@metalab.ifmo.ru',
    LinkedIn: 'https://www.linkedin.com/in/pfirrsich/',
    GoogleSC: null,
    ResearchGate: null,
  },
  {
    name: 'Ekaterina Puhtina',
    // position: 'Circuit Development',
    position_academ: null,
    personImg: seventhImg,
    description:
      'Bachelor of Radiophysics, photographer, cameraman, and video editor who solders PCBs of Swarmodroids and makes videos and photos with robots.',
    email: 'ekaterina.puhtina@metalab.ifmo.ru',
    LinkedIn: null,
    GoogleSC: 'https://scholar.google.com/citations?user=NbJvLeQAAAAJ&hl=en',
    ResearchGate: 'https://www.researchgate.net/profile/Ekaterina-Puhtina',
  },
];
